import React from "react";

function Footer({ content }) {
  return (
    <footer>
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-brand-logo">
              <div className="footer-brand-logo-dot"></div>
              {content?.brandName}
            </div>
            <p>{content?.brandDescription}</p>
            <div className="footer-socials">
              {(content?.socials || []).map((social) => (
                <a href={social.href} className="footer-social-btn" key={social.label}>
                  {social.label}
                </a>
              ))}
            </div>
          </div>
          {(content?.columns || []).map((column) => (
            <div className="footer-col" key={column.title}>
              <h5>{column.title}</h5>
              <ul>
                {(column.links || []).map((link) => (
                  <li key={`${column.title}-${link.label}`}>
                    <a href={link.href}>{link.label}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="footer-bottom">
          <p>{content?.copyright}</p>
          <div className="footer-badges">
            {(content?.badges || []).map((badge) => (
              <span className="footer-badge" key={badge}>
                {badge}
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
